/**
 *
 * Sponsors Block
 *
 * Handling sponsor lightbox
 */

jQuery(document).ready(function ($) {

	$('.sponsor-img-wrap > a').click(function(e) {
		e.preventDefault();
		var sponsorExpandElementId = $(this).attr('id');
		$('#single-sponsor-wrap-expanded-'+sponsorExpandElementId).fadeIn();
	});
	
	$('.close-single-sponsor-wrap-expanded').click(function() {
		var sponsorExpandElementId = $(this).attr('id');
		$('#single-sponsor-wrap-expanded-'+sponsorExpandElementId).fadeOut();
	});
  
});